export default __webpack_public_path__ + "static/media/Dis_PrintCheque.114d54de.svg";